import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';

const pedidoDistratoAssociadoConfig = {
  id: 'pedido_distrato_associado',
  nome: 'Pedido de Distrato de Associado',
  descricao: 'Solicitação de registro de distrato de associado',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoDistratoAssociado', tipoDocumentoProcesso: 460, name: 'Contrato de Distrato de Associado', description: 'Contrato de distrato de associado assinado digitalmente pelo(s) sócio(s), associado e duas testemunhas', required: true }
    ]
  },

  paymentConfig: {
    amount: 102.00
  },

  protocoloConfig: {
    modeloRequerimento: '269',
    tiposAssunto: '818',
    tipoPedido: '361'
  },

  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE,

  tituloConfig: {
    tipoLancamentoId: 104,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection()
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoDistratoAssociadoConfig;
